import { render, staticRenderFns } from "./printProduct.vue?vue&type=template&id=5b1b1a20&"
import script from "./printProduct.vue?vue&type=script&lang=tsx&"
export * from "./printProduct.vue?vue&type=script&lang=tsx&"
import style0 from "./printProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports